import { lazyRetry } from '@/shared/core/lazyRetry';

export const GuestLanding = lazyRetry(() => import('./pages/GuestLanding'));
export const GuestDashboard = lazyRetry(() => import('./pages/GuestDashboard'));
export const GuestTransport = lazyRetry(() => import('./pages/GuestTransport'));
export const GuestStays = lazyRetry(() => import('./pages/GuestStays'));
export const GuestTours = lazyRetry(() => import('./pages/GuestTours'));
export const GuestRequests = lazyRetry(() => import('./pages/GuestRequests'));
